import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/shared/components/auth/AuthProvider';
import { fetchBootstrapData } from '../api/users.api';
import type { ICockpitBootstrapData } from '@condo/domain';

const BOOTSTRAP_QUERY_KEY = ['bootstrap-data'] as const;

export function useBootstrapData<T = ICockpitBootstrapData>(select?: (bootstrap: ICockpitBootstrapData) => T) {
    const { user, loading } = useAuth();
    const queryClient = useQueryClient();
    const enabled = !!user && !loading;
    const query = useQuery({
        queryKey: BOOTSTRAP_QUERY_KEY,
        queryFn: fetchBootstrapData,
        staleTime: 30 * 60 * 1000,
        enabled,
        select,
    });

    useEffect(() => {
        if (!loading && !user) {
            queryClient.removeQueries({ queryKey: BOOTSTRAP_QUERY_KEY });
        }
    }, [loading, user, queryClient]);

    return { ...query, data: enabled ? query.data : undefined };
}
